import type { Meta } from '../ThemeTypes';

const meta: Meta = {
  title: 'Utilita Optimise',
  description:
    "Utilita Optimise will buy and store energy when it's cheap, and sell it back to the grid when it’s expensive.",
  manifestPath: '/utilitaManifest.json',
};

export default meta;
